import { render, staticRenderFns } from "./frameChoose.vue?vue&type=template&id=1d5c3c3f&scoped=true&"
import script from "./frameChoose.vue?vue&type=script&lang=js&"
export * from "./frameChoose.vue?vue&type=script&lang=js&"
import style0 from "./frameChoose.vue?vue&type=style&index=0&id=1d5c3c3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c3c3f",
  null
  
)

export default component.exports